import type { IParagraphEntry } from "~/models/IUserEntry";

export function useFetchParagraphEntryByType<T extends IParagraphEntry["type"]>(
  paragraphId: MaybeRef<number | undefined>,
  type: T
) {
  const { loggedIn } = storeToRefs(useUserStore());

  const enabled = computed(() =>
    Boolean((type === "schema" || loggedIn.value) && unref(paragraphId))
  );

  const query = useQuery({
    ...queries().paragraphs.byId(paragraphId)._ctx.entriesByParagraph(type),
    enabled,
  });

  const { amended: entries } = useAddLocalEntriesForParagraph(
    () => query.data.value ?? [],
    paragraphId,
    type
  );

  return {
    query,
    data: entries as ComputedRef<Extract<IParagraphEntry, { type: T }>[]>,
    enabled,
  };
}
